import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class GeocoderService {
  constructor(public http: HttpClient) { }
  public lat;
  public lng;

  public getCoordinates(address:  string): Observable<any>  {
    this.http
      .get(
        'https://maps.googleapis.com/maps/api/geocode/json?address=' +
          address +
          '&key=AIzaSyDW6NfiIPV8i307l2XcikaXe9ho6W5h5lc'
      )
      .subscribe((results: any) => {
        
        this.lat = results.results[0].geometry.location.lat;
        this.lng = results.results[0].geometry.location.lng;
      });
    return this.lat, this.lng;
  }
}
